import * as z from 'zod'
import { priceRequiredScheme } from '~/shared/lib/schemas'

export const withdrawalSchema = z.object({
  amount: priceRequiredScheme,
})
export type TypeFormSchema = z.infer<typeof withdrawalSchema>
export type FormValues = TypeFormSchema
